import { Chip, styled, TextField } from '@mui/material';

interface AutoCompleteInputProps {
  isMobile: boolean;
  errorMessage?: string;
}

const LIGHT_GREY = '#808b96';
const DARK_GREY = '#f4f5f6';
const DARK_ORANGE = '#ff8000';

export const AutoCompleteInput = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'isMobile' && prop !== 'errorMessage',
})((props: AutoCompleteInputProps) => {
  const inputStyles = {
    borderColor: props.errorMessage ? DARK_ORANGE : LIGHT_GREY,
    borderWidth: props.errorMessage ? '2px' : '1px',
  };

  return {
    '& .MuiOutlinedInput-root': {
      height: props.isMobile ? '50px' : '60px',

      '& .MuiOutlinedInput-notchedOutline': inputStyles,
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': inputStyles,
      },
      '&:hover:not(.Mui-focused)': {
        '& .MuiOutlinedInput-notchedOutline': inputStyles,
      },
      '& .MuiAutocomplete-popupIndicator': {
        marginRight: '4px',
      },
    },
  };
});

export const AutoCompleteLabel = styled(Chip)(() => ({
  backgroundColor: DARK_GREY,
  borderRadius: '4px',
  fontWeight: '500',
  fontSize: '16px',
}));
